var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('UserManager',{model:{value:(_vm.users),callback:function ($$v) {_vm.users=$$v},expression:"users"}}),_c('ServiceManager',{attrs:{"users":_vm.users}}),_c('ContractManager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }